import { scrollToId } from "@/lib/scroll";

const legal = ["Politique de confidentialité", "Conditions d'utilisation", "Mentions légales"];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#05080C] py-10" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 sm:px-6 md:flex-row lg:px-8">
        <button
          data-testid="footer-logo"
          onClick={() => scrollToId("hero")}
          className="font-display flex items-center gap-2.5 text-sm font-bold tracking-tight text-white"
        >
          <span className="h-2 w-2 rounded-full bg-emerald-400" />
          Web<span className="text-emerald-400">&</span>Conversion
        </button>
        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2">
          <a
            href="tel:+14389696957"
            data-testid="footer-phone-link"
            className="text-xs font-semibold text-emerald-300 transition-colors hover:text-emerald-200"
          >
            +1 438 969 6957
          </a>
          {legal.map((l) => (
            <a
              key={l}
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-xs text-gray-500 transition-colors hover:text-gray-300"
            >
              {l}
            </a>
          ))}
        </nav>
        <p className="text-xs text-gray-600" data-testid="footer-copyright">
          © 2026 Web & Conversion. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
